import { useNavigate } from "react-router-dom";
import AuthContentWrapper from "./components/AuthContentWrapper";
import CustomIcon from "../../common/components/image/CustomIcon";
import { Column, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import Translate from "../../common/translate/Translate";
import CustomInput from "../../common/components/input/CustomInput";
import { useEffect, useState } from "react";
import CustomTooltip from "../../common/components/button/CustomTooltip";
import ValidUtil from "../../common/utils/ValidUtil";
// import CustomRadios from "../../common/modals/radio/CustomRadios";
import CustomCheckbox from "../../common/components/checkbox/CustomCheckbox";
import CustomPopup from "../../common/components/popup/CustomPopup";
import AuthService from "../../service/AuthService";
import CustomRadios from "../../common/components/radio/CustomRadios";
import { Theme } from "../../common/Theme";

function JoinPage() {
    const navigate = useNavigate();
    const service = new AuthService();

    function handleHistoryBack() {
        navigate(-1);
    }

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [birth, setBirth] = useState("2000.01.01");
    const [isFranchise, setIsFranchise] = useState("y");
    const [franchiseCode, setFranchiseCode] = useState("");
    const [userType, setUserType] = useState("franchiseAdmin");
    const [emailAgreement, setEmailAgreement] = useState(false);

    useEffect(() => {
        if (isFranchise === "n") {
            setFranchiseCode("");
            setUserType("shopOwner");
        }
    }, [isFranchise]);

    // Cancel Modal
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };
    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);
        navigate("/auth/login");
    };

    // valid
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isButtonActive, setIsButtonActive] = useState(false);

    useEffect(() => {
        if (
            username.length > 0 &&
            password.length > 0 &&
            birth.length > 8 &&
            password === confirmPassword &&
            ValidUtil.validatePassword(password)
        ) {
            setIsButtonActive(true);
        } else {
            setIsButtonActive(false);
        }
    }, [username, password, birth, confirmPassword]);

    // error popup
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    async function handleJoin() {
        if (
            !(username.length > 0 && password.length > 0 && birth.length > 0) ||
            !(password === confirmPassword) ||
            !ValidUtil.validatePassword(password)
        ) {
            return;
        } else if (!ValidUtil.isValidEmail(username)) {
            setIsEmailValid(false);
            return;
        }

        try {
            await service.join({
                userid: username,
                password: password,
                birthday: birth,
                isSubscribe: emailAgreement ? "Y" : "N",
            });

            navigate(`/auth/message?email=${username}`);
        } catch (error) {
            setPopupMessage(error.message);
            setIsPopupOpened(true);
        }
    }

    return (
        <AuthContentWrapper
            contentPadding={"20px"}
            overflowX={"visible"}
            contentMaxHeight={"816px"}
            header={
                <>
                    <CustomIcon iconName={"undo"} size={"36px"} onClick={handleHistoryBack} cursor={"pointer"} />
                    <SizedBox height={"6px"} />
                    <Column justifyContent={"center"}>
                        <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                            Account
                        </T1Text>
                        <SizedBox height={"10px"} />
                        <C2Text fontColor={Theme.color.gray500}>Enter your account information</C2Text>
                        <SizedBox height={"44px"} />
                    </Column>
                </>
            }
            footer={
                <>
                    <SizedBox height={"28px"} />
                    <FullWidthButton onClick={handleJoin} text={"Ok"} isActive={isButtonActive} />
                    <SizedBox height={"10px"} />
                    <FullWidthButton
                        onClick={() => setIsCancelPopupOpen(true)}
                        text={"Cancel"}
                        backgroundColor={Theme.color.white}
                        isActive={true}
                    />
                    <SizedBox height={"20px"} />
                    <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                        <C3Text fontColor={Theme.color.gray500}>
                            Copyright © LG Electronics. All Rights Reserved.
                        </C3Text>
                    </Row>
                    <SizedBox height={"20px"} />
                </>
            }
        >
            <Column padding={"0 40px"} justifyContent={"flex-start"} alignItem={"flex-start"} overflow={"visible"}>
                <C2Text fontWeight={"500"}>{Translate("auth.id")}</C2Text>
                <SizedBox height={"6px"} />
                <CustomInput
                    placeholder={Translate("placeholder.id")}
                    type={"email"}
                    inputType={"email"}
                    padding={"15px 16px"}
                    inputValue={username}
                    setInputValue={setUsername}
                    isValid={isEmailValid}
                />
                <SizedBox height={"15px"} />
                <Row overflowX={"visible"}>
                    <C2Text fontWeight={"500"}>{Translate("auth.password")}</C2Text>
                    <SizedBox width={"6px"} />
                    <CustomTooltip>
                        <C3Text fontColor={Theme.color.gray500}>
                            Enter a valid password. Password must be 8 characters or more and have at least two of the
                            following: alphabets, numbers and symbols.
                        </C3Text>
                    </CustomTooltip>
                </Row>
                <SizedBox height={"6px"} />
                <CustomInput
                    placeholder={Translate("placeholder.password")}
                    type={"password"}
                    padding={"14px 16px"}
                    inputValue={password}
                    setInputValue={setPassword}
                    isValid={ValidUtil.validatePassword(password) || !(password.length > 0)}
                />
                <SizedBox height={"15px"} />
                <C2Text fontWeight={"500"}>Confirm Password</C2Text>
                <SizedBox height={"6px"} />
                <CustomInput
                    placeholder={Translate("placeholder.password")}
                    type={"confirmPassword"}
                    padding={"14px 16px"}
                    inputValue={confirmPassword}
                    setInputValue={setConfirmPassword}
                    isValid={password === confirmPassword || !(confirmPassword.length > 0)}
                />
                <SizedBox height={"15px"} />
                <C2Text fontWeight={"500"}>Birth</C2Text>
                <SizedBox height={"6px"} />
                <CustomInput
                    type={"birth"}
                    padding={"14px 16px"}
                    inputValue={birth}
                    setInputValue={setBirth}
                    isValid={true}
                />
                <SizedBox height={"15px"} />
                <C2Text fontWeight={"500"}>Franchise Y/N</C2Text>
                <SizedBox height={"15px"} />
                <CustomRadios
                    options={[
                        { value: "y", label: "Yes" },
                        { value: "n", label: "No" },
                    ]}
                    selectedOption={isFranchise}
                    setSelectedOption={setIsFranchise}
                />
                {isFranchise === "y" && (
                    <>
                        <SizedBox height={"15px"} />
                        <C2Text fontWeight={"500"}>Franchise Code</C2Text>
                        <SizedBox height={"6px"} />
                        <CustomInput
                            type={"normal"}
                            placeholder={"Enter Franchise Code"}
                            padding={"14px 16px"}
                            inputValue={franchiseCode}
                            setInputValue={setFranchiseCode}
                            isValid={true}
                        />
                        <SizedBox height={"15px"} />
                        <C2Text fontWeight={"500"}>User Type</C2Text>
                        <SizedBox height={"6px"} />
                        <CustomInput
                            type={"select"}
                            placeholder={"Enter Franchise Code"}
                            dropdownValues={[
                                { label: "Franchise Admin", value: "franchiseAdmin" },
                                { label: "Call Center", value: "callCenter" },
                                { label: "Shop Owner", value: "shopOwner" },
                            ]}
                            padding={"14px 16px"}
                            inputValue={userType}
                            setInputValue={setUserType}
                        />
                    </>
                )}

                <SizedBox height={"15px"} />
                <C2Text fontWeight={"500"}>Opt-in Agreement</C2Text>
                <SizedBox height={"6px"} />
                <C3Text fontColor={Theme.color.gray500}>
                    Opt in to receive the latest news and special offers from the laundromat. Regardless of your
                    subscription preference, important service updates and policy changes will still be sent via email.
                </C3Text>
                <SizedBox height={"16px"} />
                <Row>
                    <CustomCheckbox
                        checked={emailAgreement}
                        onClick={() => {
                            setEmailAgreement(!emailAgreement);
                        }}
                    />
                    <SizedBox width={"14px"} />
                    <C2Text fontWeight={"500"}>Email Subscription Agreement</C2Text>
                </Row>
            </Column>
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
        </AuthContentWrapper>
    );
}

export default JoinPage;
